// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider-arrow[data-v-4d94024e]{width:10.625rem;padding-left:3rem}.swiper-slide[data-v-4d94024e]{-webkit-box-sizing:border-box;box-sizing:border-box}.custom-swiper-container[data-v-4d94024e]{margin-top:4.5rem}@media only screen and (max-width: 959px){.custom-swiper-container[data-v-4d94024e]{margin-top:1.75rem}}", ""]);
// Exports
module.exports = exports;
